import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Link,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as _ser from '../../../_redux/_services/JobPostingSlice';
import { Encrypt } from '../../../_utilities/_encryptDecryptHelper';
import { setBreadCrumb } from '../../../_utilities/breadCrumb';
import GetJobId from '../../../_utilities/GetJobId';
import {
  getActiveDaysLabel,
  GetTimeZone,
} from '../../../_utilities/GetTimeZone';
import { getValueUtilitie } from '../../../_utilities/utilities';
import ApplicantCard from '../../../components/ApplicantCard/ApplicantCard';
import {
  jobPostingCardTitleEnum,
  jobPostingCardTypeEnum,
} from '../../../constants/constants';
import { ApplicantEdit } from '../../../Icons/ApplicantEdit';
import { Clone } from '../../../Icons/Clone';

import { GetUserId } from '../../../_utilities/getUserInfo';
const initalState = { data: null, message: '', isloader: true };

const PostingsViewNew = (props) => {
  const [notes, setNotes] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [auditlogData, setAuditlogData] = useState([]);
  const [postingData, setPostingData] = useState(null);
  const [isFullWidth, setIsFullWidth] = useState(true);
  const [showAddDocuments, setShowAddDocuments] = useState(false);
  const [showAddassociatedApplicants, setShowAddassociatedApplicants] =
    useState(false);
  const [viewJob, setViewJob] = useState(false);
  const [showAddNotes, setShowAddNotes] = useState(false);
  const [recruiterObj, setRecruiterObj] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [recruiterContribution, setRecruiterContribution] = useState([]);
  const [candidateStatus, setCandidateStatus] = useState([]);
  const [open, setOpen] = useState(false);

  let getJobCode = props.getData ? null : GetJobId();

  const column1Ref = useRef(null);
  const column2Ref = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const actionLinks = {
    screeningQuestionsUrl: `/ats/layout/jobpostings/screeningquestions/${getJobCode}`,
    documentsUrl: `/ats/layout/jobpostings/documents/${getJobCode}`,
    notesUrl: `/ats/layout/jobpostings/notes/${getJobCode}`,
    auditinfoUrl: `/ats/layout/jobpostings/auditinfo/${getJobCode}`,
  };

  useEffect(() => {
    if (getJobCode) {
      onLoadEvents(getJobCode);
    }
  }, [getJobCode]);

  useEffect(() => {
    if (props.getData) {
      onLoadEvents(props.getData.jobopeningID);
    }
  }, [props.getData]);

  const onLoadEvents = async (id) => {
    dispatch(_ser.jobpostingsbyidAsync(id));
    dispatch(_ser.getAssociatedApplicantsAsync(id));
    dispatch(_ser.getdocumentsAsync(id));
    dispatch(_ser.getnotesAsync(id));
    dispatch(_ser.getQuestionsListAsync(id));
    let payLoad = { type: 'jobopening', typeId: id };
    dispatch(_ser.getPostingsCommentsAsync(payLoad));
    let userId = await GetUserId();
    if (userId) {
      dispatch(_ser.getManagerTeamleadAsync(' ', userId));
    }
  };

  const recruiterList = useSelector(
    (state) => state.GetManagerTeamlead.recruiter
  );
  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const AccociatedApplicantsData = useSelector(
    (state) => state.GetAssociatedApplicants.data
  );
  const GetDocumentsdata = useSelector((state) => state.Getdocuments.data);
  const notesData = useSelector((state) => state.Getnotes.data);
  const AuditlogResponse = useSelector(
    (state) => state.GetPostingsComments.data
  );
  const { data: questionsData, code: questionStatus } = useSelector(
    (state) => state.GetQuestionsList
  );

  useEffect(() => {
    if (recruiterList && recruiterList.length > 0) {
      const data = JSON.parse(JSON.stringify(recruiterList));
      let newArray = [];
      data.forEach((list) => {
        let obj = {
          id: list.id.toString(),
          name: `${list.firstName} ${list.lastName}`,
          emailId: list.emailId,
        };
        newArray.push(obj);
      });
      setRecruiterObj(newArray);
    }
  }, [recruiterList]);

  useEffect(() => {
    if (questionStatus === 200 && questionsData?.length > 0) {
      const updatedQuestions = questionsData.map((item) => ({
        id: item.id,
        question: item.question,
      }));
      setQuestions(updatedQuestions);
      dispatch(_ser.getQuestionsListStartReducer(initalState));
    }
  }, [questionsData, questionStatus, initalState]);

  useEffect(() => {
    if (getDetails && recruiterObj.length > 0) {
      let cloneData = JSON.parse(JSON.stringify(getDetails));
      setViewJob(cloneData);
      cloneData.recruiters = cloneData.recruiters
        ? JSON.parse(cloneData.recruiters)
        : [];
      cloneData.customFields = cloneData.customFields
        ? JSON.parse(cloneData.customFields)
        : [];
      let recruiterTeamObj = [
        {
          id: 1,
          key: 'Manager',
          value: getValueUtilitie(
            'id',
            cloneData.manager,
            recruiterObj,
            'name'
          ),
        },
        {
          id: 2,
          key: 'Team Lead',
          value: getValueUtilitie(
            'id',
            cloneData.teamLead,
            recruiterObj,
            'name'
          ),
        },
        {
          id: 3,
          key: 'Recruiter',
          value: cloneData.recruiters
            .map((r) => getValueUtilitie('id', r, recruiterObj, 'name'))
            .join(', '),
        },
      ].filter((item) => item.value && item.value !== '');

      let clientDetailsObj = [
        { id: 1, key: 'Client', value: cloneData?.clientName || '' },
        { id: 2, key: 'End Client', value: cloneData?.endClientName || '' },
        {
          id: 3,
          key: 'Client Bill Rate',
          value: cloneData?.clientBillRate || '',
        },
        { id: 4, key: 'Pay Rate Salary', value: cloneData?.payBillRate || '' },
      ].filter((item) => item.value && item.value !== '');

      let additionInfoObj = cloneData.customFields
        ?.map((field, index) => ({
          id: index + 1,
          key: field.key,
          value: field.value,
        }))
        .filter((item) => item.value && item.value !== '');

      let portalsData = [];
      if (parseInt(cloneData.VSPortal) === 1) {
        portalsData.push({
          label: 'Vendor',
          icon: `${process.env.PUBLIC_URL}/assests/img/vendorIcon.svg`,
          bg: '#dce9ff',
          color: '#0062ff',
        });
      }
      if (parseInt(cloneData.EPortal) === 1) {
        portalsData.push({
          label: 'Employee',
          icon: `${process.env.PUBLIC_URL}/assests/img/employeeIcon.svg`,
          bg: '#d9f7e5',
          color: '#008b2e',
        });
      }
      if (parseInt(cloneData.JBPortal) === 1) {
        portalsData.push({
          label: 'Job Board',
          icon: `${process.env.PUBLIC_URL}/assests/img/JBIcon.svg`,
          bg: '#eadaff',
          color: '#8734ff',
        });
      }
      if (parseInt(cloneData.CSPortal) === 1) {
        portalsData.push({
          label: 'Cloud Sourcing',
          icon: `${process.env.PUBLIC_URL}/assests/img/cloudIcon.svg`,
          bg: '#fff4c7',
          color: '#b68400',
        });
      }
      let postindData = {
        recruiterTeam: recruiterTeamObj,
        clientDetails: clientDetailsObj,
        jobDesc: cloneData.jobDesc,
        jobDescForSM: cloneData.jobDescForSM,
        portals: portalsData,
        additionInfo: additionInfoObj,
        userfullName: [cloneData?.userFirstName, cloneData?.userLastName]
          .filter(Boolean)
          .join(' '),
        activeDays: getActiveDaysLabel(cloneData?.createdAt),
        createdDate: GetTimeZone(cloneData?.createdAt),
        skills: [
          {
            id: 1,
            groupName: 'Primary Skills',
            skillsList: Array.isArray(cloneData?.primarySkills)
              ? cloneData.primarySkills
              : (cloneData?.primarySkills || '')
                  .split(',')
                  .map((x) => x.trim())
                  .filter(Boolean),
          },
          {
            id: 2,
            groupName: 'Secondary Skills',
            skillsList: Array.isArray(cloneData?.secondarySkills)
              ? cloneData.secondarySkills
              : (cloneData?.secondarySkills || '')
                  .split(',')
                  .map((x) => x.trim())
                  .filter(Boolean),
          },
        ],
      };
      setPostingData(postindData);
      let updateSkills = cloneData.primarySkills.replace(/\n/g, ',');
      Encrypt(updateSkills, 'getSkills');
      localStorage.setItem('JobIdentifier', cloneData.affindaIdentifier);

      let additionalData = {
        jobStatus: cloneData?.jobStatus || '',
        lastUpdated: GetTimeZone(cloneData?.updatedAt) || '',
        jobType: cloneData?.jobType.replace(/,/g, ', ') || '',
        workModel: cloneData?.workModel || '',
        jobLocation: cloneData.location || '',
        experience:
          additionInfoObj?.filter((x) => x.key === 'Experience')[0]?.value ||
          '',
        segment: cloneData?.segmentId || '',
        priority: cloneData?.priority || '',
      };
      let name = `${cloneData.jobTitle} (${cloneData.jobCode})`;
      setBreadCrumb(cloneData.id, name, 'Job Code', additionalData);
    }
  }, [getDetails, recruiterObj]);

  useEffect(() => {
    if (GetDocumentsdata !== null) {
      let docData = JSON.parse(JSON.stringify(GetDocumentsdata));
      if (docData.length > 0) {
        const documentsData = JSON.parse(docData[0]?.docs || '[]');
        setDocuments(documentsData.reverse());
        dispatch(_ser.getdocumentsStartReducer(initalState));
      } else {
        setDocuments([]);
      }
    }
  }, [GetDocumentsdata]);

  useEffect(() => {
    if (
      AccociatedApplicantsData !== null &&
      AccociatedApplicantsData !== undefined
    ) {
      if (AccociatedApplicantsData.length > 0) {
        const myData = JSON.parse(JSON.stringify(AccociatedApplicantsData));
        if (myData !== undefined) {
          let statusObj = getGroupByCounts(myData, 'status');
          let submittedByUserObj = getGroupByCounts(myData, 'submittedByUser');
          setCandidateStatus(
            Object.keys(statusObj)?.map((key) => ({
              name: key,
              value: statusObj[key],
            })) || []
          );
          setRecruiterContribution(
            Object.keys(submittedByUserObj)?.map((key) => ({
              name: key,
              value: submittedByUserObj[key],
            })) || []
          );
        }
        dispatch(_ser.getAssociatedApplicantsStartReducer(initalState));
      }
    }
  }, [AccociatedApplicantsData]);

  useEffect(() => {
    if (notesData !== null) {
      let data = JSON.parse(JSON.stringify(notesData));
      setNotes(data);
      dispatch(_ser.getnotesStartReducer(initalState));
    }
  }, [notesData]);

  useEffect(() => {
    if (AuditlogResponse && AuditlogResponse.length > 0) {
      const auditlogData = AuditlogResponse.map((item, i) => ({
        id: item.id || i,
        key: ['Name', 'Action Performed', 'Date and Time'],
        value: [
          item?.fullName || '',
          item?.action || '',
          GetTimeZone(item?.createdAt),
        ],
      }));
      setAuditlogData(auditlogData);
      dispatch(_ser.getPostingsCommentsStartReducer(initalState));
    }
  }, [AuditlogResponse]);

  useEffect(() => {
    const updateHeights = () => {
      if (column1Ref.current && column2Ref.current) {
        const height1 = column1Ref.current.offsetHeight;
        const height2 = column2Ref.current.offsetHeight;
        if (height1 + 20 < height2) {
          setIsFullWidth(false);
        } else {
          setIsFullWidth(true);
        }
        console.log('height1:', height1, 'height2:', height2);
      }
    };
    if (getDetails) {
      updateHeights();
      window.addEventListener('resize', updateHeights);
      return () => window.removeEventListener('resize', updateHeights);
    }
  }, [getDetails]);

  const getGroupByCounts = (data, type) => {
    return data.reduce((acc, item) => {
      const key = item[type] || 'Unknown';
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});
  };

  const s3data = useSelector((state) => state.DownloadFileFromS3.data);
  const [DocName, setDocName] = useState('');

  useEffect(() => {
    if (s3data) {
      const link = document.createElement('a');
      link.href = s3data;
      link.download = DocName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    dispatch(_ser.downloadFileFromS3StartReducer(initalState));
  }, [s3data]);

  const renderingUI = (object, cardType, title) => {
    let isAction = false,
      actionLink = null,
      nodata = '',
      type = '',
      isAddSection = false;
    switch (cardType) {
      case jobPostingCardTitleEnum.SCREENING_QUESTIONS:
        isAction = Boolean(questions.length > 0);
        actionLink = actionLinks.screeningQuestionsUrl;
        nodata = 'No screening questions found';
        type = jobPostingCardTypeEnum.SERIAL_NUMBER_LIST;
        break;
      case jobPostingCardTitleEnum.RECRUITING_TEAM:
      case jobPostingCardTitleEnum.CLIENT_DETAILS:
      case jobPostingCardTitleEnum.ADDITIONAL_INFORMATION:
        type = jobPostingCardTypeEnum.TABLE;
        break;
      case jobPostingCardTitleEnum.RECRUITER_CONTRIBUTION:
        type = jobPostingCardTypeEnum.COMPONENT;
        object = <RecruiterContributionComponent data={object} />;
        break;
      case jobPostingCardTitleEnum.CANDIDATE_STATUS:
        type = jobPostingCardTypeEnum.COMPONENT;
        object = <CandidateStatusComponent data={object} />;
        break;
      case jobPostingCardTitleEnum.JOB_DESC:
      case jobPostingCardTitleEnum.JOB_DESC_FOR_SM:
        type = jobPostingCardTypeEnum.DATA;
        break;
      case jobPostingCardTitleEnum.SKILLS:
        type = jobPostingCardTypeEnum.LIST_WITH_GROUP;
        break;
      case jobPostingCardTitleEnum.NOTES:
        isAction = Boolean(notes.length > 0);
        actionLink = actionLinks.notesUrl;
        nodata = 'No notes found';
        type = jobPostingCardTypeEnum.CUSTOM_LAYOUT;
        break;
      case jobPostingCardTitleEnum.AUDIT_INFO:
        isAction = Boolean(auditlogData.length > 0);
        actionLink = actionLinks.auditinfoUrl;
        nodata = 'No audit Info found';
        type = jobPostingCardTypeEnum.LIST_WITH_COLUMN;
        break;
      case jobPostingCardTitleEnum.PORTALS:
        type = jobPostingCardTypeEnum.LIST_WITH_LABEL;
        break;
      case jobPostingCardTitleEnum.DOCUMENTS:
        isAction = Boolean(documents.length > 0);
        actionLink = actionLinks.documentsUrl;
        nodata = 'No documents found';
        type = jobPostingCardTypeEnum.LIST_WITH_CARD;
        break;
    }

    const onReceivePropsHandler = (type) => {
      if (typeof type === 'boolean') {
        // GetData();
      } else {
        if (type.includes('associated')) {
          setShowAddassociatedApplicants(true);
        } else if (type.includes('documents')) {
          setShowAddDocuments(true);
        } else if (type.includes('notes')) {
          setShowAddNotes(true);
        }
      }
    };

    const onDowloadHandler = (value) => {
      // console.log("value: ++++++++++++++", value);
      DownloadFileFromS3(value.docUrl, 'download');
    };

    const DownloadFileFromS3 = async (object, type) => {
      dispatch(_ser.downloadFileFromS3Async(getJobCode, object, type));
      setDocName(object.docUrl);
    };

    return (
      <ApplicantCard
        data={object}
        title={cardType}
        isAction={isAction}
        actionLink={actionLink}
        nodata={nodata}
        type={type}
        isAddSection={isAddSection}
        onReceiveProps={onReceivePropsHandler}
        onDowloadHandler={onDowloadHandler}
      />
    );
  };

  const onCloneHandler = async () => {
    const customHeaders = { jobCode: viewJob.jobCode, userId: viewJob.userId };
    await dispatch(_ser.getListofQuestionsAsync(viewJob.id, customHeaders));
    navigate('/ats/layout/jobpostings/create/jobdetails');
  };

  return (
    <>
      <div className="applicant-view-header" style={{ marginTop: '-100px' }}>
        <Tooltip title="Clone" placement="top">
          <div
            onClick={() => {
              setOpen(true);
            }}
          >
            <Clone />
          </div>
        </Tooltip>
        <Tooltip title="Edit" placement="top">
          <div
            onClick={() => {
              dispatch(_ser.jobpostingsbyidStartReducer(initalState));
              navigate(`/ats/layout/jobpostings/edit/${getJobCode}`);
            }}
          >
            <ApplicantEdit />
          </div>
        </Tooltip>
      </div>
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
          borderRadius: 2,
          border: '1px solid #e0e0e0',
          height: '58px',
          mb: 3,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flexWrap: 'wrap',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <img
              src={`${process.env.PUBLIC_URL}/assests/user-outerline.svg`}
              width={20}
              height={20}
            />
            <Typography variant="body2" style={{ fontSize: '16px' }}>
              Created by : {postingData?.userfullName || 'N/A'}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <img
              src={`${process.env.PUBLIC_URL}/assests/calendar-outerline.svg`}
              width={20}
              height={20}
            />
            <Typography
              variant="body2"
              style={{ fontSize: '16px' }}
            ></Typography>
            Created Date : {postingData?.createdDate}
          </Box>
        </Box>

        <Chip
          icon={<AccessTimeIcon color="#2e7d32" />}
          label={postingData?.activeDays || 'N/A'}
          variant="outlined"
          sx={{
            bgcolor: '#e8f5e9',
            color: '#2e7d32',
            borderColor: '#2e7d32',
            fontSize: '16px',
            padding: '20px 13px',
            borderRadius: '30px',
          }}
        />
      </Paper>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: '0 auto' }}>
          {postingData?.recruiterTeam &&
            postingData?.recruiterTeam.length > 0 && (
              <>
                {renderingUI(
                  postingData?.recruiterTeam,
                  jobPostingCardTitleEnum.RECRUITING_TEAM
                )}
              </>
            )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: '0 auto' }}>
          {recruiterContribution && recruiterContribution.length > 0 && (
            <>
              {renderingUI(
                recruiterContribution,
                jobPostingCardTitleEnum.RECRUITER_CONTRIBUTION
              )}
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: '0 auto' }}>
          {candidateStatus && candidateStatus.length > 0 && (
            <>
              {renderingUI(
                candidateStatus,
                jobPostingCardTitleEnum.CANDIDATE_STATUS
              )}
            </>
          )}
        </Grid>
        {postingData && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={8}
            style={{ margin: '0 auto' }}
          >
            <div ref={column1Ref}>
              {postingData?.jobDesc && (
                <>
                  {renderingUI(
                    postingData?.jobDesc,
                    jobPostingCardTitleEnum.JOB_DESC
                  )}
                </>
              )}
              {postingData?.jobDescForSM && (
                <>
                  {renderingUI(
                    postingData?.jobDescForSM,
                    jobPostingCardTitleEnum.JOB_DESC_FOR_SM
                  )}
                </>
              )}
              {postingData?.additionInfo &&
                postingData.additionInfo.length > 0 && (
                  <>
                    {renderingUI(
                      postingData?.additionInfo,
                      jobPostingCardTitleEnum.ADDITIONAL_INFORMATION
                    )}
                  </>
                )}
              {postingData?.skills && postingData.skills.length > 0 && (
                <>
                  {renderingUI(
                    postingData?.skills,
                    jobPostingCardTitleEnum.SKILLS
                  )}
                </>
              )}
            </div>
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12} lg={4} style={{ margin: '0 auto' }}>
          <div ref={column2Ref}>
            {postingData?.clientDetails && (
              <>
                {renderingUI(
                  postingData?.clientDetails,
                  jobPostingCardTitleEnum.CLIENT_DETAILS
                )}
              </>
            )}
            {questions && questions?.length > 0 && (
              <>
                {renderingUI(
                  questions.slice(0, 3),
                  jobPostingCardTitleEnum.SCREENING_QUESTIONS
                )}
              </>
            )}
            {postingData?.portals && (
              <>
                {renderingUI(
                  postingData?.portals,
                  jobPostingCardTitleEnum.PORTALS
                )}
              </>
            )}
            {documents.length > 0 && (
              <>
                {renderingUI(
                  documents?.slice(0, 2),
                  jobPostingCardTitleEnum.DOCUMENTS
                )}
              </>
            )}
            {notes && (
              <>
                {renderingUI(notes?.slice(0, 1), jobPostingCardTitleEnum.NOTES)}
              </>
            )}
            {auditlogData && (
              <>
                {renderingUI(
                  auditlogData?.slice(0, 1),
                  jobPostingCardTitleEnum.AUDIT_INFO
                )}
              </>
            )}
          </div>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        keepMounted
        onClose={() => {
          setOpen(false);
        }}
        aria-describedby="alert-dialog"
        style={{ marginTop: '-26%' }}
      >
        <Box sx={{ width: '395px' }}>
          <DialogTitle className="diabtn">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText className="diabtnjob" id="alert-dialog">
              <p className="btntext">Are you sure you want to clone ?</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="warning-actionbtns">
            <Button
              onClick={() => {
                setOpen(false);
              }}
            >
              <Link href="#" color="#000" underline="always">
                Cancel
              </Link>
            </Button>
            <Button onClick={onCloneHandler}>Yes</Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default PostingsViewNew;

const RecruiterContributionComponent = ({ data }) => {
  const colors = [
    '#8ba3bc',
    '#9fbb7d',
    '#dcc882',
    '#e76f51',
    '#2a9d8f',
    '#c88d68',
    '#6e6a52',
    '#5c6c74',
    '#6c5444',
    '#c9c9c9',
    '#9c9494',
  ];

  const chartData = data.map((item, index) => ({
    id: index,
    value: item.value,
    label: item.name,
    color: colors[index % colors.length],
  }));

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <PieChart
        series={[
          {
            data: chartData,
            innerRadius: 0,
            outerRadius: 80,
            paddingAngle: 2,
            cornerRadius: 4,
            valueFormatter: (v) => `${v.value}`,
          },
        ]}
        height={200}
        width={200}
        margin={{ right: 0 }}
        slotProps={{ legend: { hidden: true } }}
      />

      {/* Custom Legend */}
      <Stack spacing={1}>
        {chartData.map((item, i) => (
          <Stack key={i} direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 15,
                height: 14,
                backgroundColor: item.color,
                borderRadius: '3px',
              }}
            />
            <Typography variant="body2">{item.label}</Typography>
          </Stack>
        ))}
      </Stack>
    </div>
  );
};

// Candidate Status Component
const CandidateStatusComponent = ({ data }) => {
  const colors = [
    '#8ba3bc',
    '#9fbb7d',
    '#dcc882',
    '#e76f51',
    '#2a9d8f',
    '#c88d68',
    '#6e6a52',
    '#5c6c74',
    '#6c5444',
    '#c9c9c9',
    '#9c9494',
  ];

  const chartData = data.map((item, index) => ({
    id: index,
    value: item.value,
    label: item.name,
    color: colors[index % colors.length],
  }));

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <PieChart
        series={[
          {
            data: data.map((item) => ({
              id: item.name,
              value: item.value,
              label: item.name,
            })),
            innerRadius: 50,
            outerRadius: 80,
          },
        ]}
        colors={[
          '#8ba3bc',
          '#9fbb7d',
          '#dcc882',
          '#e76f51',
          '#2a9d8f',
          '#c88d68',
          '#6e6a52',
          '#5c6c74',
          '#6c5444',
          '#c9c9c9',
          '#9c9494',
        ]}
        // width={300}
        height={250}
        slotProps={{ legend: { hidden: true } }}
      />
      {/* Custom Legend */}
      <Stack spacing={1}>
        {chartData.map((item, i) => (
          <Stack key={i} direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 15,
                height: 14,
                backgroundColor: item.color,
                borderRadius: '3px',
              }}
            />
            <Typography variant="body2">{item.label}</Typography>
          </Stack>
        ))}
      </Stack>
    </div>
  );
};
